import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  .wf-scope * { box-sizing: border-box; }



  .wf-scope .app-root {
    min-height: 100vh;
    background: #0a0a0f;
    color: #e2e8f0;
    font-family: 'DM Sans', sans-serif;
  }

  /* ── Header ── */
  .wf-scope .header {
    margin-top: 65px;
    background: rgba(10,10,15,0.95);
    border-bottom: 1px solid rgba(255,255,255,0.06);
    backdrop-filter: blur(20px);
    position: sticky;
    top: 0;
    z-index: 40;
  }
  .wf-scope .header-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 32px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .wf-scope .header-logo {
    width: 44px;
    height: 44px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 0 20px rgba(99,102,241,0.3);
  }
  .wf-scope .header-title {
    font-family: 'Syne', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #f1f5f9;
    letter-spacing: -0.3px;
  }
  .wf-scope .header-subtitle {
    font-size: 13px;
    color: #64748b;
    font-weight: 400;
    margin-top: 1px;
  }
  .wf-scope .header-badge {
    margin-left: auto;
    padding: 5px 12px;
    background: rgba(99,102,241,0.12);
    border: 1px solid rgba(99,102,241,0.25);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: #818cf8;
    letter-spacing: 0.3px;
  }

  /* ── Main ── */
  .wf-scope .main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 32px;
  }

  /* ── Step Indicator ── */
  .wf-scope .steps {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }
  .wf-scope .step {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .wf-scope .step-num {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
    transition: all 0.3s ease;
  }
  .wf-scope .step-num.done { background: rgba(34,197,94,0.15); border: 1.5px solid rgba(34,197,94,0.4); color: #4ade80; }
  .wf-scope .step-num.active { background: rgba(99,102,241,0.2); border: 1.5px solid rgba(99,102,241,0.5); color: #818cf8; }
  .wf-scope .step-num.idle { background: rgba(255,255,255,0.04); border: 1.5px solid rgba(255,255,255,0.1); color: #334155; }
  .wf-scope .step-label { font-size: 13px; font-weight: 600; }
  .wf-scope .step-label.done { color: #4ade80; }
  .wf-scope .step-label.active { color: #818cf8; }
  .wf-scope .step-label.idle { color: #334155; }
  .wf-scope .step-line { flex: 1; height: 1px; background: rgba(255,255,255,0.07); margin: 0 14px; min-width: 20px; }

  /* ── Upload Card ── */
  .wf-scope .upload-card {
    background: #111118;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 20px;
    padding: 32px;
    margin-bottom: 24px;
  }
  .wf-scope .section-label {
    font-family: 'Syne', sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 20px;
  }
  .wf-scope .upload-zone {
    border: 1.5px dashed rgba(99,102,241,0.3);
    border-radius: 16px;
    padding: 48px 32px;
    text-align: center;
    cursor: pointer;
    transition: all 0.25s ease;
    background: rgba(99,102,241,0.03);
    display: block;
    width: 100%;
  }
  .wf-scope .upload-zone:hover {
    border-color: rgba(99,102,241,0.6);
    background: rgba(99,102,241,0.06);
  }
  .wf-scope .upload-icon-wrap {
    width: 72px;
    height: 72px;
    background: linear-gradient(135deg, rgba(99,102,241,0.15), rgba(139,92,246,0.15));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    border: 1px solid rgba(99,102,241,0.2);
    transition: transform 0.25s ease;
  }
  .wf-scope .upload-zone:hover .upload-icon-wrap {
    transform: scale(1.08);
  }
  .wf-scope .upload-preview-img {
    max-width: 180px;
    max-height: 140px;
    border-radius: 10px;
    border: 2px solid rgba(255,255,255,0.1);
    margin: 0 auto 20px;
    display: block;
  }
  .wf-scope .upload-text-main {
    font-size: 15px;
    font-weight: 500;
    color: #cbd5e1;
    margin-bottom: 6px;
  }
  .wf-scope .upload-text-sub {
    font-size: 13px;
    color: #475569;
  }

  /* ── Platform Selection ── */
  .wf-scope .platform-select-card {
    background: #111118;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 20px;
    padding: 28px 32px;
    margin-bottom: 24px;
  }
  .wf-scope .platform-hint {
    font-size: 13px;
    color: #475569;
    margin-bottom: 20px;
    margin-top: -8px;
    line-height: 1.5;
  }
  .wf-scope .platform-select-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
    gap: 12px;
    margin-bottom: 22px;
  }
  .wf-scope .psc {
    position: relative;
    padding: 18px 16px;
    border-radius: 14px;
    border: 1.5px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.02);
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .wf-scope .psc:hover { border-color: rgba(255,255,255,0.14); background: rgba(255,255,255,0.04); }
  .wf-scope .psc.psc-sel { background: rgba(99,102,241,0.08); border-color: rgba(99,102,241,0.35); }
  .wf-scope .psc.psc-sel.psc-vid { background: rgba(239,68,68,0.07); border-color: rgba(239,68,68,0.28); }
  .wf-scope .psc-icon { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .wf-scope .psc-name { font-size: 13px; font-weight: 600; color: #cbd5e1; }
  .wf-scope .psc-type { font-size: 11px; font-weight: 500; color: #475569; margin-top: -4px; }
  .wf-scope .psc-check {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1.5px solid rgba(255,255,255,0.12);
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }
  .wf-scope .psc-sel .psc-check { background: #6366f1; border-color: #6366f1; }
  .wf-scope .psc-sel.psc-vid .psc-check { background: #ef4444; border-color: #ef4444; }

  /* ── Selection Summary ── */
  .wf-scope .sel-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 13px 17px;
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 12px;
    margin-bottom: 20px;
    font-size: 13px;
    color: #64748b;
    flex-wrap: wrap;
  }
  .wf-scope .stag { padding: 4px 10px; border-radius: 6px; font-size: 12px; font-weight: 600; }
  .wf-scope .stag-img { background: rgba(99,102,241,0.1); color: #818cf8; border: 1px solid rgba(99,102,241,0.2); }
  .wf-scope .stag-vid { background: rgba(239,68,68,0.1); color: #f87171; border: 1px solid rgba(239,68,68,0.2); }

  /* ── Buttons ── */
  .wf-scope .btn-generate {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 13px 32px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    color: white;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 20px rgba(99,102,241,0.3);
  }
  .wf-scope .btn-generate:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(99,102,241,0.4); }
  .wf-scope .btn-generate:disabled { background: rgba(255,255,255,0.06); color: #334155; cursor: not-allowed; box-shadow: none; }

  .wf-scope .btn-back {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 9px;
    font-size: 13px;
    color: #64748b;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    transition: all 0.2s ease;
  }
  .wf-scope .btn-back:hover { background: rgba(255,255,255,0.07); color: #94a3b8; }

  /* ── Processing pill ── */
  .wf-scope .processing-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(99,102,241,0.1);
    border: 1px solid rgba(99,102,241,0.2);
    border-radius: 20px;
    font-size: 13px;
    color: #818cf8;
    font-weight: 500;
  }
  .wf-scope .pill-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(129,140,248,0.3);
    border-top-color: #818cf8;
    border-radius: 50%;
    animation: wf-spin 0.8s linear infinite;
  }

  /* ── Error ── */
  .wf-scope .error-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding: 14px 18px;
    background: rgba(239,68,68,0.08);
    border: 1px solid rgba(239,68,68,0.2);
    border-radius: 12px;
    color: #fca5a5;
    font-size: 14px;
  }

  /* ── Generated Section ── */
  .wf-scope .generated-header {
    display: flex;
    align-items: baseline;
    gap: 12px;
    margin-bottom: 24px;
  }
  .wf-scope .generated-title {
    font-family: 'Syne', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: #f1f5f9;
    letter-spacing: -0.3px;
  }
  .wf-scope .generated-count {
    font-size: 13px;
    color: #475569;
    font-weight: 400;
  }

  .wf-scope .platforms-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
  }

  /* ── Platform Card ── */
  .wf-scope .platform-card {
    background: #111118;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 18px;
    overflow: hidden;
    transition: all 0.25s ease;
  }
  .wf-scope .platform-card:hover {
    border-color: rgba(255,255,255,0.12);
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0,0,0,0.4);
  }
  .wf-scope .platform-header {
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255,255,255,0.05);
  }
  .wf-scope .platform-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .wf-scope .platform-icon-dot {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .wf-scope .platform-name {
    font-family: 'Syne', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #e2e8f0;
  }
  .wf-scope .platform-status-badge {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }
  .wf-scope .badge-ready {
    background: rgba(34,197,94,0.1);
    border: 1px solid rgba(34,197,94,0.2);
    color: #4ade80;
  }
  .wf-scope .badge-processing {
    background: rgba(99,102,241,0.1);
    border: 1px solid rgba(99,102,241,0.2);
    color: #818cf8;
  }
  .wf-scope .badge-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: currentColor;
  }
  .wf-scope .badge-dot.pulse {
    animation: wf-pulse-dot 1.5s ease-in-out infinite;
  }

  /* ── Media Preview ── */
  .wf-scope .media-preview {
    aspect-ratio: 1;
    background: #0d0d14;
    position: relative;
    overflow: hidden;
  }
  .wf-scope .media-preview img, .wf-scope .media-preview video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .wf-scope .media-preview.clickable { cursor: pointer; }
  .wf-scope .media-preview.clickable:hover .preview-overlay { opacity: 1; }
  .wf-scope .preview-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .wf-scope .preview-overlay-icon {
    width: 52px;
    height: 52px;
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(8px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid rgba(255,255,255,0.25);
  }
  .wf-scope .video-thumb {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #0d0d14;
  }
  .wf-scope .video-play-btn {
    width: 56px;
    height: 56px;
    background: rgba(239,68,68,0.85);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    transition: transform 0.2s ease;
  }
  .wf-scope .media-preview.clickable:hover .video-play-btn { transform: scale(1.1); }
  .wf-scope .video-thumb-label { font-size: 12px; color: #64748b; font-weight: 500; }
  .wf-scope .empty-preview {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }
  .wf-scope .empty-preview-icon { color: #1e293b; }
  .wf-scope .empty-preview-text { font-size: 12px; color: #334155; font-weight: 500; }
  .wf-scope .video-processing-overlay {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    background: #0d0d14;
  }
  .wf-scope .video-processing-ring { position: relative; width: 56px; height: 56px; }
  .wf-scope .ring-outer {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(99,102,241,0.15);
    animation: wf-ping 1.5s ease-in-out infinite;
  }
  .wf-scope .ring-inner {
    position: absolute;
    inset: 4px;
    border-radius: 50%;
    border: 2px solid transparent;
    border-top-color: #6366f1;
    border-right-color: #8b5cf6;
    animation: wf-spin 0.9s linear infinite;
  }
  .wf-scope .processing-label { font-size: 12px; color: #6366f1; font-weight: 500; }
  .wf-scope .timer-label { font-size: 11px; color: #334155; font-weight: 500; }

  /* ── Card Actions ── */
  .wf-scope .card-actions {
    padding: 14px 18px;
    display: flex;
    gap: 8px;
    border-top: 1px solid rgba(255,255,255,0.05);
  }
  .wf-scope .btn-download {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px 14px;
    background: rgba(99,102,241,0.1);
    border: 1px solid rgba(99,102,241,0.2);
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    color: #818cf8;
    text-decoration: none;
    transition: all 0.2s ease;
    cursor: pointer;
  }
  .wf-scope .btn-download:hover { background: rgba(99,102,241,0.18); border-color: rgba(99,102,241,0.4); color: #a5b4fc; }
  .wf-scope .btn-preview {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .wf-scope .btn-preview:hover { background: rgba(255,255,255,0.07); color: #94a3b8; }
  .wf-scope .btn-disabled {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px 14px;
    background: transparent;
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    color: #334155;
    cursor: not-allowed;
  }
  .wf-scope .btn-processing {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px 14px;
    background: rgba(99,102,241,0.06);
    border: 1px solid rgba(99,102,241,0.12);
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    cursor: wait;
  }
  .wf-scope .btn-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(99,102,241,0.2);
    border-top-color: #6366f1;
    border-radius: 50%;
    animation: wf-spin 0.8s linear infinite;
  }

  /* ── Publish Panel ── */
  .wf-scope .publish-panel {
    background: #111118;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 20px;
    overflow: hidden;
    margin-top: 32px;
  }
  .wf-scope .publish-panel-header {
    padding: 24px 28px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .wf-scope .publish-panel-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, rgba(16,185,129,0.15), rgba(6,182,212,0.15));
    border: 1px solid rgba(16,185,129,0.2);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .wf-scope .publish-panel-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #f1f5f9; }
  .wf-scope .publish-panel-sub { font-size: 13px; color: #475569; margin-top: 2px; }
  .wf-scope .publish-panel-body { padding: 28px; }
  .wf-scope .sub-section-label { font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: #334155; margin-bottom: 14px; }
  .wf-scope .platform-toggles { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 28px; }
  .wf-scope .toggle-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.03);
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'DM Sans', sans-serif;
  }
  .wf-scope .toggle-btn:hover:not(.toggle-disabled) { border-color: rgba(255,255,255,0.12); color: #94a3b8; }
  .wf-scope .toggle-btn.toggle-selected { background: rgba(16,185,129,0.08); border-color: rgba(16,185,129,0.25); color: #34d399; }
  .wf-scope .toggle-btn.toggle-disabled { opacity: 0.35; cursor: not-allowed; }
  .wf-scope .toggle-check {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1.5px solid rgba(255,255,255,0.15);
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }
  .wf-scope .toggle-selected .toggle-check { background: #10b981; border-color: #10b981; }

  .wf-scope .fields-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 24px;
  }
  @media (max-width: 640px) {
    .wf-scope .fields-grid { grid-template-columns: 1fr; }
    .wf-scope .platform-select-grid { grid-template-columns: 1fr 1fr; }
  }
  .wf-scope .field-label { font-size: 12px; font-weight: 600; color: #475569; letter-spacing: 0.3px; margin-bottom: 8px; display: block; }
  .wf-scope .field-hint { font-size: 11px; color: #334155; font-weight: 400; margin-left: 6px; }
  .wf-scope .field-textarea {
    width: 100%;
    padding: 12px 14px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    color: #cbd5e1;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    resize: none;
    transition: all 0.2s ease;
    outline: none;
  }
  .wf-scope .field-textarea::placeholder { color: #334155; }
  .wf-scope .field-textarea:focus { border-color: rgba(16,185,129,0.35); background: rgba(16,185,129,0.04); }
  .wf-scope .publish-actions { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
  .wf-scope .btn-publish {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 13px 28px;
    background: linear-gradient(135deg, #10b981, #0d9488);
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    color: white;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 20px rgba(16,185,129,0.25);
  }
  .wf-scope .btn-publish:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(16,185,129,0.35); }
  .wf-scope .btn-publish:disabled { background: rgba(255,255,255,0.06); color: #334155; cursor: not-allowed; box-shadow: none; }
  .wf-scope .btn-publish.publishing { background: rgba(16,185,129,0.5); cursor: wait; }
  .wf-scope .platforms-count { font-size: 13px; color: #34d399; font-weight: 500; padding: 8px 14px; background: rgba(16,185,129,0.06); border: 1px solid rgba(16,185,129,0.15); border-radius: 8px; }
  .wf-scope .result-bar { display: flex; align-items: center; gap: 12px; margin-top: 20px; padding: 14px 18px; border-radius: 12px; font-size: 14px; font-weight: 500; }
  .wf-scope .result-success { background: rgba(34,197,94,0.07); border: 1px solid rgba(34,197,94,0.15); color: #4ade80; }
  .wf-scope .result-error { background: rgba(239,68,68,0.07); border: 1px solid rgba(239,68,68,0.15); color: #fca5a5; }

  /* ── Prompt Modal ── */
  .wf-scope .modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.8);
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    backdrop-filter: blur(8px);
  }
  .wf-scope .modal-box {
    background: #111118;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    max-width: 760px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 32px 80px rgba(0,0,0,0.6);
  }
  .wf-scope .modal-header {
    padding: 24px 28px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background: #111118;
    z-index: 1;
  }
  .wf-scope .modal-title { font-family: 'Syne', sans-serif; font-size: 18px; font-weight: 700; color: #f1f5f9; }
  .wf-scope .modal-close {
    width: 32px;
    height: 32px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #64748b;
    transition: all 0.2s ease;
  }
  .wf-scope .modal-close:hover { background: rgba(255,255,255,0.08); color: #94a3b8; }
  .wf-scope .modal-body { padding: 24px 28px; }
  .wf-scope .mode-tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
    background: rgba(255,255,255,0.03);
    padding: 4px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.05);
  }
  .wf-scope .mode-tab {
    flex: 1;
    padding: 9px;
    border-radius: 7px;
    font-size: 13px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #475569;
    background: transparent;
  }
  .wf-scope .mode-tab.active { background: rgba(99,102,241,0.15); color: #818cf8; border: 1px solid rgba(99,102,241,0.2); }
  .wf-scope .prompt-fields { display: flex; flex-direction: column; gap: 16px; }
  .wf-scope .prompt-field-card {
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 12px;
    padding: 16px 18px;
  }
  .wf-scope .prompt-field-header { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
  .wf-scope .prompt-icon { width: 28px; height: 28px; border-radius: 7px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .wf-scope .prompt-field-name { font-size: 13px; font-weight: 600; color: #cbd5e1; }
  .wf-scope .prompt-textarea {
    width: 100%;
    padding: 10px 12px;
    background: rgba(0,0,0,0.3);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    color: #94a3b8;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    resize: none;
    outline: none;
    transition: all 0.2s ease;
  }
  .wf-scope .prompt-textarea::placeholder { color: #1e293b; }
  .wf-scope .prompt-textarea:focus { border-color: rgba(99,102,241,0.3); background: rgba(99,102,241,0.04); }
  .wf-scope .static-info {
    display: flex;
    gap: 14px;
    padding: 18px 20px;
    background: rgba(99,102,241,0.05);
    border: 1px solid rgba(99,102,241,0.12);
    border-radius: 12px;
  }
  .wf-scope .static-info-icon { width: 36px; height: 36px; background: rgba(99,102,241,0.15); border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .wf-scope .static-info-title { font-size: 14px; font-weight: 600; color: #e2e8f0; margin-bottom: 4px; }
  .wf-scope .static-info-text { font-size: 13px; color: #475569; line-height: 1.5; }
  .wf-scope .modal-footer {
    padding: 18px 28px;
    border-top: 1px solid rgba(255,255,255,0.05);
    display: flex;
    gap: 10px;
    position: sticky;
    bottom: 0;
    background: #111118;
  }
  .wf-scope .btn-cancel {
    padding: 11px 20px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .wf-scope .btn-cancel:hover { background: rgba(255,255,255,0.07); color: #94a3b8; }
  .wf-scope .btn-primary {
    flex: 1;
    padding: 11px 20px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 16px rgba(99,102,241,0.25);
  }
  .wf-scope .btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }

  /* ── Fullscreen Modal ── */
  .wf-scope .fullscreen-modal {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.96);
    z-index: 60;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    backdrop-filter: blur(12px);
  }
  .wf-scope .fullscreen-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #94a3b8;
    z-index: 10;
    transition: all 0.2s ease;
  }
  .wf-scope .fullscreen-close:hover { background: rgba(255,255,255,0.12); color: white; }
  .wf-scope .fullscreen-media {
    max-width: 100%;
    max-height: 90vh;
    border-radius: 16px;
    object-fit: contain;
    box-shadow: 0 24px 80px rgba(0,0,0,0.5);
  }

  @keyframes wf-spin { to { transform: rotate(360deg); } }
  @keyframes wf-pulse-dot { 0%,100%{opacity:1} 50%{opacity:0.3} }
  @keyframes wf-ping { 0%{transform:scale(1);opacity:0.6} 100%{transform:scale(1.8);opacity:0} }

  /* ── Embedded mode (inside Campaign Automation) ── */
  .wf-scope.wf-embedded .app-root { min-height: 0; }
  .wf-scope.wf-embedded .header { margin-top: 0; position: static; }
  .wf-scope.wf-embedded .header-inner { padding: 18px 24px; }
  .wf-scope.wf-embedded .main { padding: 28px 24px; }
  @media (max-width: 640px) {
    .wf-scope.wf-embedded .header-inner { padding: 14px 16px; }
    .wf-scope.wf-embedded .main { padding: 20px 14px; }
    .wf-scope.wf-embedded .upload-card { padding: 20px 16px; }
    .wf-scope.wf-embedded .steps { overflow-x: auto; }
    .wf-scope.wf-embedded .step-line { margin: 0 8px; }
  }
`;

// ── All platform definitions ──
const ALL_PLATFORMS = [
  { id: 'facebook',        name: 'Facebook',    type: 'image', iconColor: '#1877F2', iconBg: 'rgba(24,119,242,0.15)',  svgPath: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z' },
  { id: 'instagram',       name: 'Instagram',   type: 'image', iconColor: '#E1306C', iconBg: 'rgba(225,48,108,0.15)',  svgPath: 'M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01M7.5 20.5h9a4 4 0 004-4v-9a4 4 0 00-4-4h-9a4 4 0 00-4 4v9a4 4 0 004 4z' },
  { id: 'linkedin',        name: 'LinkedIn',    type: 'image', iconColor: '#0A66C2', iconBg: 'rgba(10,102,194,0.15)',  svgPath: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M2 6.5a2 2 0 114 0 2 2 0 01-4 0z' },
  { id: 'instagram_story', name: 'Insta Story', type: 'video', iconColor: '#a855f7', iconBg: 'rgba(168,85,247,0.15)',  svgPath: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
  { id: 'youtube_shorts',  name: 'YT Shorts',   type: 'video', iconColor: '#EF4444', iconBg: 'rgba(239,68,68,0.15)',   svgPath: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
];

const DEFAULT_PROMPTS = {
  message:   'Call with client and company',
  facebook:  'Resize and adapt this image to a 1:1 square format (1080x1080) for a Facebook feed post. Do not crop, remove, replace, or modify any existing elements in the image.',
  instagram: 'Resize and adapt this image to a 1:1 square format (1080x1080) for an Instagram feed post. Do not crop, remove, replace, or modify any existing elements in the image.',
  linkedin:  'Resize and adapt this image to a 1:1 square format (1080x1080) for a LinkedIn feed post. Do not crop, remove, replace, or modify any existing elements in the image.',
  video:     'Create a 6-second cinematic social media advertisement using the provided image. Animation style: - Smooth camera pan and zoom - Subtle depth and parallax - Soft lighting transitions - Realistic motion Rules: - Do not change or replace the main subject - Do not add text, logos, or watermarks - Maintain natural realism - Extend background only if needed - Its a telecom Company ad video So Company name and sentences there in photo should remain same with company logo Aspect ratio: 9:16 Output: High-quality promotional video.',
};

function Home({ embedded = false, onContentReady }) {
  const navigate = useNavigate();

  // ── Access Guard ───────────────────────────────────────────────
  // Standalone page: super-admin only (unchanged).
  // Embedded inside Campaign Automation: that page already handles its own
  // access, so we don't redirect the user away from it.
  useEffect(() => {
    if (embedded) return;
    try {
      const userData = localStorage.getItem('userData');
      if (!userData) { navigate('/'); return; }
      const user = JSON.parse(userData);
      if (user?.role !== 'super_admin' && user?.email !== 'info@easylearn.net.in') {
        navigate('/');
      }
    } catch {
      navigate('/');
    }
  }, [navigate, embedded]);
  // ──────────────────────────────────────────────────────────────
  // ── Step: 'upload' | 'select' | 'results' ──
  const [step, setStep] = useState('upload');

  const [uploadedImage,    setUploadedImage]    = useState(null);
  const [pendingFile,      setPendingFile]      = useState(null);
  const [isProcessing,     setIsProcessing]     = useState(false);
  const [generatedOutputs, setGeneratedOutputs] = useState(null);
  const [selectedImage,    setSelectedImage]    = useState(null);
  const [error,            setError]            = useState(null);

  // Which platforms user selected for generation
  const [selPlatforms, setSelPlatforms] = useState({});

  // WebSocket
  const [wsToken,         setWsToken]         = useState(null);
  const [videoProcessing, setVideoProcessing] = useState(false);
  const wsRef = useRef(null);
  const genIdRef = useRef(null); // id of the current generation (used by onContentReady)

  // Processing stage
  const [processingStage, setProcessingStage] = useState('');
  const [estimatedTime,   setEstimatedTime]   = useState(null);
  const [elapsedTime,     setElapsedTime]      = useState(0);
  const timerRef = useRef(null);

  // Prompt modal
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [promptMode,      setPromptMode]      = useState('static');
  const [customPrompts,   setCustomPrompts]   = useState({ facebook: '', instagram: '', linkedin: '', video: '' });
  const [tempPrompts,     setTempPrompts]     = useState({ facebook: '', instagram: '', linkedin: '', video: '' });

  // Publish
  const [publishSelections, setPublishSelections] = useState({});
  const [publishCaption,    setPublishCaption]    = useState('');
  const [publishHashtags,   setPublishHashtags]   = useState('');
  const [isPublishing,      setIsPublishing]      = useState(false);
  const [publishResult,     setPublishResult]     = useState(null);
  const [publishError,      setPublishError]      = useState(null);

  // ── Derived flags ──
  const needsImage = ALL_PLATFORMS.some(p => p.type === 'image' && selPlatforms[p.id]);
  const needsVideo = ALL_PLATFORMS.some(p => p.type === 'video' && selPlatforms[p.id]);
  const selImgPlatforms = ALL_PLATFORMS.filter(p => p.type === 'image' && selPlatforms[p.id]);
  const selVidPlatforms = ALL_PLATFORMS.filter(p => p.type === 'video' && selPlatforms[p.id]);
  const anySelected = Object.values(selPlatforms).some(Boolean);

  useEffect(() => {
    return () => {
      if (wsRef.current) wsRef.current.close();
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  useEffect(() => {
    if (wsToken && !wsRef.current) connectWebSocket(wsToken);
  }, [wsToken]);

  useEffect(() => {
    if (videoProcessing) {
      timerRef.current = setInterval(() => setElapsedTime(p => p + 1), 1000);
    } else {
      if (timerRef.current) clearInterval(timerRef.current);
      setElapsedTime(0);
    }
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [videoProcessing]);

  const formatTime = (s) => `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`;

  // ── Upload handler ──
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      setUploadedImage(ev.target.result);
      setPendingFile(file);
      setError(null);
      setGeneratedOutputs(null);
      setSelPlatforms({});
      setPublishSelections({});
      setPublishResult(null);
      setPublishError(null);
      setWsToken(null);
      setVideoProcessing(false);
      setStep('select');
    };
    reader.readAsDataURL(file);
  };

  const togglePlatform = (id) => setSelPlatforms(p => ({ ...p, [id]: !p[id] }));

  // ── Open prompt modal ──
  const handleClickGenerate = () => {
    setPromptMode('static');
    setTempPrompts({ ...customPrompts });
    setShowPromptModal(true);
  };

  const closePromptModal = () => setShowPromptModal(false);

  const savePrompts = () => {
    setCustomPrompts({ ...tempPrompts });
    setShowPromptModal(false);
    startGenerate(tempPrompts);
  };

  const useDefaultPrompts = () => {
    setShowPromptModal(false);
    startGenerate(DEFAULT_PROMPTS);
  };

  const handlePromptChange = (key, value) => setTempPrompts(p => ({ ...p, [key]: value }));

  // ── Core generate ──
  const startGenerate = async (prompts) => {
    genIdRef.current = 'gen_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    setIsProcessing(true);
    setStep('results');
    setProcessingStage('Uploading');
    setEstimatedTime('3–5 minutes');
    setElapsedTime(0);

    try {
      const formData = new FormData();
      formData.append('file', pendingFile);
      formData.append('message', DEFAULT_PROMPTS.message);
      formData.append('generate_images', needsImage ? '1' : '0');
      formData.append('generate_video',  needsVideo  ? '1' : '0');

      if (needsImage) {
        if (selPlatforms.facebook)  formData.append('facebook_prompt',  prompts.facebook  || DEFAULT_PROMPTS.facebook);
        if (selPlatforms.instagram) formData.append('instagram_prompt', prompts.instagram || DEFAULT_PROMPTS.instagram);
        if (selPlatforms.linkedin)  formData.append('linkedin_prompt',  prompts.linkedin  || DEFAULT_PROMPTS.linkedin);
      }
      if (needsVideo) {
        formData.append('video_prompt', prompts.video || DEFAULT_PROMPTS.video);
      }

      const basicAuth = 'Basic ' + btoa('ISF_Media:123456');
      const uploadResponse = await fetch('https://isf.tail2992e2.ts.net:8443/webhook/media/intake', {
        method: 'POST',
        headers: { 'Authorization': basicAuth },
        body: formData,
      });

      if (!uploadResponse.ok) throw new Error(`Upload failed: ${uploadResponse.status}`);

      setProcessingStage('Generating');
      const responseData = await uploadResponse.json();
      const data = Array.isArray(responseData) ? responseData[0] : responseData;

      const token = data.ws_token;
      if (token && needsVideo) setWsToken(token);

      let imagesData = typeof data.images === 'string' ? JSON.parse(data.images) : (data.images || {});
      const outputs = {};

      if (needsImage) {
        if (selPlatforms.facebook  && imagesData.image_1) outputs.facebook  = { url: imagesData.image_1.preview_url,  type: 'image', download_url: imagesData.image_1.download_url };
        if (selPlatforms.instagram && imagesData.image_2) outputs.instagram = { url: imagesData.image_2.preview_url, type: 'image', download_url: imagesData.image_2.download_url };
        if (selPlatforms.linkedin  && imagesData.image_3) outputs.linkedin  = { url: imagesData.image_3.preview_url,  type: 'image', download_url: imagesData.image_3.download_url };
      }
      if (needsVideo) {
        outputs.video = { url: null, type: 'video', download_url: null, processing: true };
      }

      setGeneratedOutputs(outputs);
      if (onContentReady) { try { onContentReady({ id: genIdRef.current, outputs }); } catch { /* optional hook */ } }
      setProcessingStage('');
      setIsProcessing(false);
    } catch (err) {
      setError('Failed to process image. Please try again.');
      setIsProcessing(false);
      setProcessingStage('');
      setStep('select');
    }
  };

  // ── WebSocket ──
  const connectWebSocket = (token) => {
    const genId = genIdRef.current;
    // Own relay on isf-main-api (replaces third-party ghana-websockets Easypanel server)
    const wsUrl = `wss://dolphin-app-33jp4.ondigitalocean.app/relay/ws/${token}`;
    setVideoProcessing(true);
    try {
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;
      ws.onopen = () => {};
      ws.onmessage = (event) => {
        let data;
        try { data = JSON.parse(event.data); } catch { return; }
        if (data.type === 'video_ready') {
          setGeneratedOutputs(prev => ({
            ...prev,
            video: { url: data.video_url, type: 'video', download_url: data.video_url },
          }));
          setVideoProcessing(false);
          if (onContentReady) { try { onContentReady({ id: genId, outputs: { video: { url: data.video_url, type: 'video', download_url: data.video_url } } }); } catch { /* optional hook */ } }
          if (wsRef.current) wsRef.current.close();
        }
      };
      ws.onerror = () => { setVideoProcessing(false); setError('Video processing failed. Please try again.'); wsRef.current = null; };
      ws.onclose = () => { wsRef.current = null; };
    } catch {
      setVideoProcessing(false);
    }
  };

  // ── Publish ──
  const handlePublishCheckbox = (key) => setPublishSelections(p => ({ ...p, [key]: !p[key] }));

  const handlePublish = async () => {
    setIsPublishing(true);
    setPublishResult(null);
    setPublishError(null);

    const hashtagArray = publishHashtags.split(/[\s,#]+/).map(h => h.replace('#', '').trim()).filter(Boolean);
    const platformsPayload = {};
    const videoUrl = generatedOutputs?.video?.url;

    if (publishSelections.facebook  && generatedOutputs?.facebook?.url)  platformsPayload.facebook        = { enabled: true, media_url: generatedOutputs.facebook.url,  media_type: 'image', caption: publishCaption, hashtags: hashtagArray };
    if (publishSelections.instagram && generatedOutputs?.instagram?.url) platformsPayload.instagram       = { enabled: true, media_url: generatedOutputs.instagram.url, media_type: 'image', caption: publishCaption, hashtags: hashtagArray };
    if (publishSelections.linkedin  && generatedOutputs?.linkedin?.url)  platformsPayload.linkedin        = { enabled: true, media_url: generatedOutputs.linkedin.url,  media_type: 'image', caption: publishCaption, hashtags: hashtagArray };
    if (publishSelections.instagram_story && videoUrl)                   platformsPayload.instagram_story = { enabled: true, media_url: videoUrl, media_type: 'video' };
    if (publishSelections.youtube_shorts  && videoUrl)                   platformsPayload.youtube_shorts  = { enabled: true, media_url: videoUrl, media_type: 'video', caption: publishCaption, hashtags: hashtagArray };
    try {
      const response = await fetch('https://isf.tail2992e2.ts.net:8443/webhook/social-media-post', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ platforms: platformsPayload }),
      });
      
      // response.ok check hata do, directly success maan lo
      const text = await response.text();
      let result;
      try { result = JSON.parse(text); } catch { result = { success: true }; }
      
      setPublishResult(result);  // success show karo
    } catch (err) {
      setPublishError(err.message || 'Failed to publish. Please try again.');
    } finally {
      setIsPublishing(false);
    }
  };

  const openImageModal  = (url, type) => setSelectedImage({ url, type });
  const closeImageModal = () => setSelectedImage(null);

  // ── Step state helper ──
  const stepState = (s) => {
    if (s === 'upload')  return step === 'upload' ? 'active' : 'done';
    if (s === 'select')  return step === 'upload' ? 'idle' : step === 'select' ? 'active' : 'done';
    return step === 'results' ? 'active' : 'idle';
  };

  // ── Output cards — deduplicated video ──
  const outputCards = [];
  const videoAdded = { added: false };
  ALL_PLATFORMS.forEach(p => {
    if (!selPlatforms[p.id]) return;
    if (p.type === 'video') {
      if (!videoAdded.added) {
        outputCards.push({ id: 'video', name: 'Video', isVideo: true, outputKey: 'video', iconColor: '#EF4444', iconBg: 'rgba(239,68,68,0.15)', svgPath: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' });
        videoAdded.added = true;
      }
    } else {
      outputCards.push({ id: p.id, name: p.name, isVideo: false, outputKey: p.id, iconColor: p.iconColor, iconBg: p.iconBg, svgPath: p.svgPath });
    }
  });

  // Prompt fields — only for selected platforms
  const promptFields = [
    needsImage && selPlatforms.facebook  && { key: 'facebook',  label: 'Facebook',  iconColor: '#1877F2', iconBg: 'rgba(24,119,242,0.15)' },
    needsImage && selPlatforms.instagram && { key: 'instagram', label: 'Instagram', iconColor: '#E1306C', iconBg: 'rgba(225,48,108,0.15)' },
    needsImage && selPlatforms.linkedin  && { key: 'linkedin',  label: 'LinkedIn',  iconColor: '#0A66C2', iconBg: 'rgba(10,102,194,0.15)' },
    needsVideo                            && { key: 'video',     label: 'Video',     iconColor: '#EF4444', iconBg: 'rgba(239,68,68,0.15)'  },
  ].filter(Boolean);

  // Publish toggles — only for platforms that were selected for generation
  const publishPlatforms = ALL_PLATFORMS
    .filter(p => selPlatforms[p.id])
    .map(p => {
      const outputKey = p.type === 'video' ? 'video' : p.id;
      return { key: p.id, label: p.name, needsContent: !!generatedOutputs?.[outputKey]?.url };
    });

  return (
    <div className={`wf-scope${embedded ? ' wf-embedded' : ''}`}>
    <div className="app-root">
      <style>{styles}</style>

      {/* Header */}
      <header className="header">
        <div className="header-inner">
          <div>
            <div className="header-title">AI Media Generator</div>
          </div>
        </div>
      </header>

      <main className="main">

        {/* Step Indicator */}
        <div className="steps">
          {[['upload', 'Upload'], ['select', 'Select Platforms'], ['results', 'Results']].map(([s, label], i, arr) => (
            <div key={s} className="step" style={{ flex: i < arr.length - 1 ? 1 : 0 }}>
              <div className={`step-num ${stepState(s)}`}>
                {stepState(s) === 'done'
                  ? <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                  : i + 1}
              </div>
              <span className={`step-label ${stepState(s)}`}>{label}</span>
              {i < arr.length - 1 && <div className="step-line" />}
            </div>
          ))}
        </div>

        {/* ── STEP 1 & 2: Upload + Select ── */}
        {(step === 'upload' || step === 'select') && (
          <>
            {/* Upload */}
            <div className="upload-card">
              <div className="section-label">Step 1 — Upload Image</div>
              <label className="upload-zone">
                <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />
                {uploadedImage
                  ? <img src={uploadedImage} alt="Preview" className="upload-preview-img" />
                  : <div className="upload-icon-wrap">
                      <svg width="28" height="28" fill="none" stroke="#818cf8" strokeWidth="1.8" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                    </div>
                }
                <p className="upload-text-main">{uploadedImage ? 'Click to replace image' : 'Click to upload or drag & drop'}</p>
                <p className="upload-text-sub">PNG, JPG, GIF up to 10MB</p>
              </label>
            </div>

            {/* Platform Selection */}
            {step === 'select' && (
              <div className="platform-select-card">
                <div className="section-label">Step 2 — Choose Platforms to Generate For</div>
                <p className="platform-hint">
                  Only selected platforms will be generated. Image platforms won't use video credits and vice versa.
                </p>

                <div className="platform-select-grid">
                  {ALL_PLATFORMS.map(p => {
                    const sel = !!selPlatforms[p.id];
                    return (
                      <div
                        key={p.id}
                        className={`psc ${sel ? 'psc-sel' : ''} ${sel && p.type === 'video' ? 'psc-vid' : ''}`}
                        onClick={() => togglePlatform(p.id)}
                      >
                        <div className="psc-check">
                          {sel && <svg width="10" height="10" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>}
                        </div>
                        <div className="psc-icon" style={{ background: p.iconBg }}>
                          <svg width="16" height="16" fill="none" stroke={p.iconColor} strokeWidth="2" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d={p.svgPath} />
                          </svg>
                        </div>
                        <div>
                          <div className="psc-name">{p.name}</div>
                          <div className="psc-type">{p.type === 'image' ? '🖼 Image' : '🎬 Video'}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {anySelected && (
                  <div className="sel-summary">
                    <span style={{ color: '#475569', fontWeight: 500 }}>Will generate:</span>
                    {needsImage && (
                      <span className="stag stag-img">
                        🖼 Images — {selImgPlatforms.map(p => p.name).join(', ')}
                      </span>
                    )}
                    {needsImage && needsVideo && <span style={{ color: '#1e293b' }}>+</span>}
                    {needsVideo && (
                      <span className="stag stag-vid">
                        🎬 Video — {selVidPlatforms.map(p => p.name).join(', ')}
                      </span>
                    )}
                  </div>
                )}

                <button className="btn-generate" disabled={!anySelected} onClick={handleClickGenerate}>
                  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                  Generate Selected Content
                </button>
              </div>
            )}
          </>
        )}

        {/* ── STEP 3: Results ── */}
        {step === 'results' && (
          <>
            {/* Top bar */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
              <button
                className="btn-back"
                onClick={() => {
                  setStep('select');
                  setGeneratedOutputs(null);
                  setError(null);
                  setVideoProcessing(false);
                  if (wsRef.current) { wsRef.current.close(); wsRef.current = null; }
                }}
              >
                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                Back
              </button>
              {isProcessing && (
                <div className="processing-pill">
                  <div className="pill-spinner" />
                  {processingStage}
                  {estimatedTime && <span style={{ color: '#475569' }}>· Est. {estimatedTime}</span>}
                </div>
              )}
            </div>

            {error && (
              <div className="error-bar">
                <svg width="18" height="18" fill="none" stroke="#fca5a5" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                {error}
              </div>
            )}

            {/* Generated header */}
            <div className="generated-header">
              <span className="generated-title">Generated Content</span>
              <span className="generated-count">{outputCards.length} platform{outputCards.length !== 1 ? 's' : ''}</span>
            </div>

            {/* Output cards */}
            <div className="platforms-grid">
              {outputCards.map(card => {
                const output = generatedOutputs?.[card.outputKey];
                const hasContent = output && output.url;
                const isVideoProcessing = card.isVideo && videoProcessing && !hasContent;

                return (
                  <div key={card.id} className="platform-card">
                    <div className="platform-header">
                      <div className="platform-header-left">
                        <div className="platform-icon-dot" style={{ background: card.iconBg }}>
                          <svg width="15" height="15" fill="none" stroke={card.iconColor} strokeWidth="2" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d={card.svgPath} />
                          </svg>
                        </div>
                        <span className="platform-name">{card.name}</span>
                      </div>
                      {hasContent     && <div className="platform-status-badge badge-ready"><span className="badge-dot" />Ready</div>}
                      {isVideoProcessing && <div className="platform-status-badge badge-processing"><span className="badge-dot pulse" />Processing</div>}
                    </div>

                    <div
                      className={`media-preview ${hasContent ? 'clickable' : ''}`}
                      onClick={() => hasContent && openImageModal(output.url, output.type)}
                    >
                      {isVideoProcessing ? (
                        <div className="video-processing-overlay">
                          <div className="video-processing-ring">
                            <div className="ring-outer" />
                            <div className="ring-inner" />
                          </div>
                          <p className="processing-label">Generating Video</p>
                          <p className="timer-label">{formatTime(elapsedTime)} elapsed</p>
                        </div>
                      ) : hasContent ? (
                        card.isVideo ? (
                          <div className="video-thumb">
                            <div className="video-play-btn">
                              <svg width="22" height="22" fill="white" viewBox="0 0 20 20"><path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" /></svg>
                            </div>
                            <p className="video-thumb-label">Click to play</p>
                          </div>
                        ) : (
                          <>
                            <img
                              src={output.url}
                              alt={card.name}
                              onError={(e) => { e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"%3E%3Crect fill="%230d0d14" width="400" height="400"/%3E%3C/svg%3E'; }}
                            />
                            <div className="preview-overlay">
                              <div className="preview-overlay-icon">
                                <svg width="20" height="20" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                              </div>
                            </div>
                          </>
                        )
                      ) : isProcessing ? (
                        <div className="video-processing-overlay">
                          <div className="video-processing-ring">
                            <div className="ring-outer" />
                            <div className="ring-inner" />
                          </div>
                          <p className="processing-label">Generating…</p>
                        </div>
                      ) : (
                        <div className="empty-preview">
                          <svg className="empty-preview-icon" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                          <p className="empty-preview-text">Awaiting…</p>
                        </div>
                      )}
                    </div>

                    <div className="card-actions">
                      {hasContent ? (
                        <>
                          <a
                            href={output.download_url || output.url}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-download"
                          >
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
                            Download
                          </a>
                          <button onClick={() => openImageModal(output.url, output.type)} className="btn-preview">
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                          </button>
                        </>
                      ) : isVideoProcessing ? (
                        <div className="btn-processing">
                          <div className="btn-spinner" />
                          Processing…
                        </div>
                      ) : (
                        <div className="btn-disabled">
                          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" /></svg>
                          Not available
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Publish Panel */}
            {generatedOutputs && (
              <div className="publish-panel">
                <div className="publish-panel-header">
                  <div className="publish-panel-icon">
                    <svg width="18" height="18" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" /></svg>
                  </div>
                  <div>
                    <div className="publish-panel-title">Publish to Social Media</div>
                    <div className="publish-panel-sub">Only your selected platforms are shown here</div>
                  </div>
                </div>

                <div className="publish-panel-body">
                  <div className="sub-section-label">Select Platforms to Publish</div>
                  <div className="platform-toggles">
                    {publishPlatforms.map(({ key, label, needsContent }) => (
                      <button
                        key={key}
                        onClick={() => needsContent && handlePublishCheckbox(key)}
                        disabled={!needsContent}
                        className={`toggle-btn ${!needsContent ? 'toggle-disabled' : ''} ${publishSelections[key] ? 'toggle-selected' : ''}`}
                      >
                        <div className="toggle-check">
                          {publishSelections[key] && (
                            <svg width="10" height="10" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                          )}
                        </div>
                        {label}
                        {!needsContent && <span style={{ fontSize: 10, color: '#334155', fontWeight: 400 }}>no content</span>}
                      </button>
                    ))}
                  </div>

                  <div className="fields-grid">
                    <div>
                      <label className="field-label">Caption <span className="field-hint">all platforms</span></label>
                      <textarea
                        value={publishCaption}
                        onChange={(e) => setPublishCaption(e.target.value)}
                        rows={4}
                        placeholder="Write your post caption here…"
                        className="field-textarea"
                      />
                    </div>
                    <div>
                      <label className="field-label">Hashtags <span className="field-hint">comma or space separated</span></label>
                      <textarea
                        value={publishHashtags}
                        onChange={(e) => setPublishHashtags(e.target.value)}
                        rows={4}
                        placeholder="#marketing #socialmedia #ai"
                        className="field-textarea"
                      />
                    </div>
                  </div>

                  <div className="publish-actions">
                    <button
                      onClick={handlePublish}
                      disabled={isPublishing || !Object.values(publishSelections).some(Boolean)}
                      className={`btn-publish ${isPublishing ? 'publishing' : ''}`}
                    >
                      {isPublishing ? (
                        <>
                          <div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'wf-spin 0.8s linear infinite' }} />
                          Publishing…
                        </>
                      ) : (
                        <>
                          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" /></svg>
                          Publish Now
                        </>
                      )}
                    </button>
                    {Object.values(publishSelections).some(Boolean) && (
                      <div className="platforms-count">
                        {Object.values(publishSelections).filter(Boolean).length} platform{Object.values(publishSelections).filter(Boolean).length > 1 ? 's' : ''} selected
                      </div>
                    )}
                  </div>

                  {publishResult && (
                    <div className="result-bar result-success">
                      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                      Published successfully! Content has been sent to the selected platforms.
                    </div>
                  )}
                  {publishError && (
                    <div className="result-bar result-error">
                      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      {publishError}
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </main>

      {/* Prompt Modal */}
      {showPromptModal && (
        <div className="modal-backdrop" onClick={closePromptModal}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">Configure Prompts</div>
              <button className="modal-close" onClick={closePromptModal}>
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="mode-tabs">
                <button className={`mode-tab ${promptMode === 'static' ? 'active' : ''}`} onClick={() => setPromptMode('static')}>
                  Use Default Prompts
                </button>
                <button className={`mode-tab ${promptMode === 'custom' ? 'active' : ''}`} onClick={() => setPromptMode('custom')}>
                  Custom Prompts
                </button>
              </div>

              {promptMode === 'custom' ? (
                <div className="prompt-fields">
                  {promptFields.map(({ key, label, iconColor, iconBg }) => (
                    <div key={key} className="prompt-field-card">
                      <div className="prompt-field-header">
                        <div className="prompt-icon" style={{ background: iconBg }}>
                          <div style={{ width: 8, height: 8, borderRadius: '50%', background: iconColor }} />
                        </div>
                        <span className="prompt-field-name">{label}</span>
                      </div>
                      <textarea
                        value={tempPrompts[key]}
                        onChange={e => handlePromptChange(key, e.target.value)}
                        rows={3}
                        placeholder={`Custom prompt for ${label}…`}
                        className="prompt-textarea"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="static-info">
                  <div className="static-info-icon">
                    <svg width="18" height="18" fill="none" stroke="#818cf8" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                  </div>
                  <div>
                    <div className="static-info-title">Optimized Default Prompts</div>
                    <div className="static-info-text">
                      Will generate:
                      {needsImage && <> <strong style={{ color: '#818cf8' }}>Images</strong> for {selImgPlatforms.map(p => p.name).join(', ')}</>}
                      {needsImage && needsVideo && ' + '}
                      {needsVideo && <> <strong style={{ color: '#f87171' }}>Video</strong> for {selVidPlatforms.map(p => p.name).join(', ')}</>}.
                      {' '}Nothing else will be generated.
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn-cancel" onClick={closePromptModal}>Cancel</button>
              {promptMode === 'static' ? (
                <button className="btn-primary" onClick={useDefaultPrompts}>
                  Continue & Generate
                </button>
              ) : (
                <button className="btn-primary" onClick={savePrompts}>
                  Save & Generate
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Fullscreen modal */}
      {selectedImage && (
        <div className="fullscreen-modal" onClick={closeImageModal}>
          <button className="fullscreen-close" onClick={closeImageModal}>
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
          <div onClick={e => e.stopPropagation()}>
            {selectedImage.type === 'video' ? (
              <video src={selectedImage.url} controls autoPlay className="fullscreen-media" style={{ maxWidth: '90vw' }}>
                Your browser does not support the video tag.
              </video>
            ) : (
              <img src={selectedImage.url} alt="Full screen" className="fullscreen-media" style={{ maxWidth: '90vw' }} />
            )}
          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default Home;